import React from "react";
import { useTranslation } from "react-i18next";

import { Anchor } from "@/components/Anchor";
import { Button } from "@/components/Button";
import { CheckListItem } from "@/components/CheckList";
import { Flex, Header, Img, Text } from "@/eworkitComponents";
import { AnimatedLayoutContainer } from "@/views/components/Layout";
import { router } from "@/views/router";

import imgConvertedAccountSrc from "./converted-account.png";

import "./_converted-account.scss";

export const ConvertedAccount: React.FC = React.memo(() => {
  const baseClassName = "converted-account";
  const { t } = useTranslation("public");

  return (
    <AnimatedLayoutContainer size="md">
      <Flex direction="column" innerMargin="xl">
        <Flex direction="column" align="center">
          <Img src={imgConvertedAccountSrc} className={`${baseClassName}__img-container`} />
          <Header text={t("SESSION_CONVERTED_ACCOUNT.HEADER")} weight="bold" size="lg" />
        </Flex>

        <Flex direction="column" innerBorder innerPadding="lg">
          <Flex direction="column" innerMargin="xs">
            <CheckListItem text={t("SESSION_CONVERTED_ACCOUNT.TEXT_LINE1")} />
            <CheckListItem text={t("SESSION_CONVERTED_ACCOUNT.TEXT_LINE2")} />
          </Flex>
          <Flex direction="row">
            <Text>{t("SESSION_CONVERTED_ACCOUNT.SUMMARY")}</Text>
          </Flex>
        </Flex>

        <Flex direction="row" justify="flex-end" innerMargin="sm">
          <Anchor href={router.get("login").path}>
            <Button size="lg">
              <Text uppercase>{t("SESSION_CONVERTED_ACCOUNT.BUTTON_SURVEY")}</Text>
            </Button>
          </Anchor>
        </Flex>
      </Flex>
    </AnimatedLayoutContainer>
  );
});
